import type { GeocodingStatus } from "~domain/addresses/models/address-model.ts";

const status: Record<GeocodingStatus, string> = {
  GEOCODED: "Adresse géocodée",
  NEARBY: "Adresse à proximité",
  NON_GEOCODED: "Adresse partielle",
};

export const SITE_ADDRESS_FRENCH_LOCALE = {
  provider: {
    google: "Adresse Google",
    gouvfr: "Adresse Gouv",
  },
  status: status,
};
